import React from "react";
import submit from "submit-form";
import getAvatarUrl from "../../../../utils/get-avatar-url";

const acknowledgeAthlete = (e, athlete, activeUser, coachFromId) => {
  e.preventDefault();
  // In case the coach belongs to an organization we will open a modal
  // to let them choose to whom they want to assign the athlete
  activeUser?.organizationUserStatus
    ? submit("/actions/refresh", {
        method: "GET",
        body: {
          "modal[type]": "acknowledge-athlete",
          // passing the entire athlete since we need information from it
          acknowledgeAthlete: athlete,
        },
      })
    : submit(`/coaching-portal/athletes/acknowledge-athlete`, {
        method: "POST",
        body: {
          athleteId: athlete._id,
        },
      });
};

const UnacknowledgedAthlete = ({ athlete, activeUser }) => {
  return (
    <article className="unacknowledged">
      <div>
        <div
          className="avatar"
          style={{
            backgroundImage: `url(${getAvatarUrl(
              athlete,
              true,
              activeUser.webAppTheme
            )})`,
            backgroundPosition: "center",
            backgroundSize: "cover",
            height: 60,
            width: 60,
            flexShrink: 0,
            marginTop: 0,
            borderRadius: "100%",
          }}
        ></div>
        <div className="athlete-details">
          <p className="s1">{athlete.name || athlete.email}</p>
          {athlete.email && <p className="p6">{athlete.email}</p>}
        </div>
      </div>

      <footer>
        <a
          role="button"
          data-button-type="text"
          href="#_"
          onClick={(e) =>
            acknowledgeAthlete(e, athlete, activeUser, athlete?.coach?._id)
          }
        >
          <span>Acknowledge</span>
          {/* <img src="/img/svg/icon_arrow-right.svg" alt="acknowledge" /> */}
        </a>
      </footer>
    </article>
  );
};

export default UnacknowledgedAthlete;
